import { Box, Skeleton } from "@mui/material";

export default function DataItemCardSkeleton() {
  return (
    <Box
      sx={{
        width: "100%",
        border: "0.0625rem solid #667085",
        borderRadius: "0.675rem",
        overflow: "hidden",
        boxSizing: "border-box"
      }}
    >
      <Skeleton variant='rectangular' height={105} width={"100%"} sx={{ background: "#3a4350" }} />

      <Box sx={{ px: 24, py: "0.5rem", boxSizing: "border-box" }}>
        <Skeleton variant='text' height={12} width={"100%"} sx={{ background: "#3a4350" }} />
        <Skeleton variant='text' height={12} width={"75%"} sx={{ background: "#3a4350" }} />
      </Box>
    </Box>
  );
}
